import { put } from 'redux-saga/effects';

import { send } from '../../helpers/requests';
import { shouldFetchTasksOfProject } from './utils';

import { store } from '../store';
import * as actions from './actions';
import { ReduxState } from '../../types/redux/state';
import { TasksStoreItem } from '../../types/redux/stores/tasks.types';
import { selectShowProject, selectToken } from '../selectors';

export function* getTasksRequestSaga(payload: any): Generator<any, void, any> {
  try {
    const _store: ReduxState = store.getState();
    const res = yield send({
      url: `/tasks?projectId=${payload.data?.projectId || ''}`,
      method: 'GET',
      cache: 'default',
      token: selectToken(_store),
    });
    yield put(actions.getTasksRequestSuccess({ res, showIntacctId: _store.userSettings?.data?.showIntacctId }));
  } catch (error) {
    yield put(actions.getTasksRequestFailure(error));
  }
}

export function* getTasksOfProjectRequestSaga({ payload }: ReturnType<typeof actions.getTasksOfProjectRequest>): Generator<any, void, any> {
  const projectId = payload.projectId;
  try {
    const _store: ReduxState = store.getState();
    const showProject = selectShowProject(_store);
    if (!shouldFetchTasksOfProject(_store.tasks, projectId, showProject)) {
      yield put(actions.getTasksOfProjectStopLoading({ projectId }));
      return;
    }
    const res: TasksStoreItem[] = yield send({
      url: '/tasks',
      method: 'GET',
      cache: 'default',
      token: selectToken(_store),
      params: {
        ...payload,
        projectId: projectId === 'all' || !projectId ? '' : projectId,
      },
    });
    yield put(
      actions.getTasksOfProjectRequestSuccess({ res, showIntacctId: _store.userSettings?.data?.showIntacctId, payloadData: payload })
    );
  } catch (error) {
    yield put(actions.getTasksOfProjectRequestFailure({ error, projectId: projectId }));
  }
}
